<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;" @click="goback()"></i>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('faq')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="q-main">
        <div class="q-top" :class="{'top-mobile': common.isMobile() === true}">
            <span :class="{'top-first-mobile': common.isMobile() === true}" v-html="$t('weHereToHelpYou')"></span>
            <span v-html="$t('pleaseCheckAndSeeFindYourAnswers')"></span>
        </div>
        <div class="q-info">
          <div class="q-left" v-if="languageCur === 'en'" :style="qLeftFixedHeader">
            <span @mouseenter="imgAboutUs = 'https://res.roompai.com/static/img/question/aboutUs-blue.png'" @mouseleave="imgAboutUs = 'https://res.roompai.com/static/img/question/aboutUs-gray.png'" @click="anchorJumpLine('aboutUs')" :class="[{'left-active': anchorJumpStatus==='aboutUs'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgAboutUs" class="q-tag"></div>
              <div style="display: inline-block;">About us</div>
            </span>
            <span @mouseenter="imgMess = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgMess = 'https://res.roompai.com/static/img/question/mess-gray.png'" @click="anchorJumpLine('mess')" :class="[{'left-active': anchorJumpStatus==='mess'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgMess" class="q-tag"></div>
              <div style="display: inline-block;">General information</div>
            </span>
            <span @mouseenter="imgCreate = 'https://res.roompai.com/static/img/question/order-blue.png'" @mouseleave="imgCreate = 'https://www.roompai.com/static/img/question/order-gray.png'" @click="anchorJumpLine('create')" :class="[{'left-active': anchorJumpStatus==='create'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCreate" class="q-tag"></div>
              <div style="display: inline-block;">Booking</div>
            </span>
            <span @mouseenter="imgUpdate = 'https://res.roompai.com/static/img/question/update-blue.png'" @mouseleave="imgUpdate = 'https://res.roompai.com/static/img/question/update-gray.png'" @click="anchorJumpLine('update')" :class="[{'left-active': anchorJumpStatus==='update'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgUpdate" class="q-tag"></div>
              <div style="display: inline-block;">Modification</div>
            </span>
            <span @mouseenter="imgCancel = 'https://res.roompai.com/static/img/question/cancel-blue.png'" @mouseleave="imgCancel = 'https://res.roompai.com/static/img/question/cancel-gray.png'" @click="anchorJumpLine('cancel')" :class="[{'left-active': anchorJumpStatus==='cancel'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCancel" class="q-tag"></div>
              <div style="display: inline-block;">Cancellation</div>
            </span>
            <span @mouseenter="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-blue.png'" @mouseleave="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-gray.png'" @click="anchorJumpLine('covid')" :class="[{'left-active': anchorJumpStatus==='covid'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCovid" class="q-tag"></div>
              <div style="display: inline-block;">COVID-19</div>
            </span>
          </div>
          <!-- <el-tabs type="card" class="q-left-mobile" v-if="languageCur === 'en'">
            <el-tab-pane>
              <span slot="label" @mouseenter="imgMess = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgMess = 'https://res.roompai.com/static/img/question/mess-gray.png'"><img :src="imgMess" class="q-tag">General information</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCreate = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgCreate = 'https://res.roompai.com/static/img/question/mess-gray.png'"><img :src="imgCreate" class="q-tag">Booking</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgUpdate = 'https://res.roompai.com/static/img/question/update-blue.png'" @mouseleave="imgUpdate = 'https://res.roompai.com/static/img/question/update-gray.png'"><img :src="imgUpdate" class="q-tag">Modification</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCancel = 'https://res.roompai.com/static/img/question/cancel-blue.png'" @mouseleave="imgCancel = 'https://res.roompai.com/static/img/question/cancel-gray.png'"><img :src="imgCancel" class="q-tag">Cancellation</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-blue.png'" @mouseleave="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-gray.png'"><img :src="imgCovid" class="q-tag">COVID-19</span>
            </el-tab-pane>
          </el-tabs> -->
          <div class="q-left-mobile" v-if="languageCur === 'en'" style="padding-bottom: 10px;">
            <el-select v-model="mobileValue" :placeholder="$t('pleaseSelect')" style="width: 100%;" @change="selectVal()">
              <el-option v-for="item in mobileSelectEn" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="q-right" :class="{'right-mobile': common.isMobile() === true}" v-if="languageCur === 'en'">
            <div class="q-frequently" id="aboutUs" ref="aboutUs">
              <div class="q-title">About us</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="a1-1">
                    <div slot="title" class="questionsTitle">
                      <span>1. </span> <span class="titleContent">What is Roompai?</span>
                    </div>
                    <div class="questionsDiv">
                      <div>
                        <b>Roompai</b> is a hotel booking platform designed to help users find the best accommodations at affordable prices. The app allows users to search, compare, and book hotels for their travel needs, whether for business or leisure. Roompai ensures a seamless booking experience with up-to-date pricing, availability, and exclusive discounts for registered users.
                        <br/>
                        <b>Core Features Include:</b>
                        <ul style="margin-left: 10px">
                          <li>Search and compare hotel prices, availability, and amenities.</li>
                          <li>Book rooms easily and securely.</li>
                          <li>Exclusive offers for registered users.</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="a1-2">
                    <div slot="title" class="questionsTitle">
                      <span>2. </span>
                      <span class="titleContent">What is the purpose of Roompai?</span>
                    </div>
                    <div class="questionsDiv">
                      <div>Roompai is a hotel booking platform that helps travelers find the best deals on accommodations. It allows users to search for hotels, compare prices, and make reservations directly through the app. Our mission is to provide a user-friendly, efficient way for people to book hotels that meet their specific needs, whether for business or leisure travel.</div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="a1-3">
                    <div slot="title" class="questionsTitle">
                      <span>3. </span>
                      <span class="titleContent">How does Roompai help me with booking?</span>
                    </div>
                    <div class="questionsDiv">
                      <div>Roompai provides up-to-date pricing and availability, allowing you to compare different hotels in real-time. Our app ensures secure booking and easy management of your reservations.</div>
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="mess" ref="mess">
              <div class="q-title">General information</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="1-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">Contact</span></div>
                    <div class="questionsDiv"><!-- <div>Telephone: 86-411-00000000</div> --><div>Email: customersupport@roompai.com</div></div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="create" ref="create">
              <div class="q-title">Booking</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="2-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">How do I know whether my reservation has been confirmed?</span></div>
                    <div class="questionsDiv">Once you book a hotel, a confirmation email will be automatically sent to your email address of your account, including the reference number of your confirmed reservation. </div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-2">
                    <div slot="title" class="questionsTitle"><span>2. </span> <span class="titleContent">When will I get the confirmation email?</span></div>
                    <div class="questionsDiv">Usually, you will receive this email within 20 minutes once the reservation is made successfully. Please make sure to check the spam folder of your email in case the confirmation email ends up there.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-3">
                    <div slot="title" class="questionsTitle"><span>3. </span> <span class="titleContent">How can I check my booking details?</span></div>
                    <div class="questionsDiv">You can sign in to your account and check all your reservations in “MY TRIP” of the section “MY ACCOUNT” in Roompai’s home page. Just select one of your reservations and you will be able to see the details of the reservation selected.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-4">
                    <div slot="title" class="questionsTitle"><span>4. </span> <span class="titleContent">How can I get the voucher of my confirmed booking?</span></div>
                    <div class="questionsDiv">There are two ways for you to get the voucher. You will receive your voucher in PDF format as attachment in the confirmation email, or you can download it online.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-5">
                    <div slot="title" class="questionsTitle"><span>5. </span> <span class="titleContent">If I make a reservation for another person, should I do it in my name or in that person’s name?</span></div>
                    <div class="questionsDiv">Please input the names of the passengers who will be travelling to avoid any check-in issues on the spot.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-6">
                    <div slot="title" class="questionsTitle"><span>6. </span> <span class="titleContent">How can I get additional information of the property?</span></div>
                    <div class="questionsDiv">You can find details about the property on the property detail page. For additional information, please contact our agent or the hotel directly.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-7">
                    <div slot="title" class="questionsTitle"><span>7. </span> <span class="titleContent">For each room, do I have to inform the names of all passengers?</span></div>
                    <div class="questionsDiv">Not necessarily. You should at least inform the name of the lead guest of each room that you are going to book.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-8">
                    <div slot="title" class="questionsTitle"><span>8. </span> <span class="titleContent">If I have special request, can it be guaranteed?</span></div>
                    <div class="questionsDiv">We will inform the hotel about your special requests if possible. However, please be aware that the special requests cannot be guaranteed. It will be subject to the hotel’s availability.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-9">
                    <div slot="title" class="questionsTitle"><span>9. </span> <span class="titleContent">What can I do if the room at the hotel is not same as I booked?</span></div>
                    <div class="questionsDiv">Please be assured that our agents will try their best to help you in this case. Please call: 0086-411-84949537</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-10">
                    <div slot="title" class="questionsTitle"><span>10. </span> <span class="titleContent">What should I do if the hotel requests me to pay the room fees on the spot?</span></div>
                    <div class="questionsDiv">Please keep any necessary invoices or payment proof and contact us. Our agents will resolve the issue with the hotel and refund you as soon as possible.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-11">
                    <div slot="title" class="questionsTitle"><span>11. </span> <span class="titleContent">What does the booking status mean?</span></div>
                    <div class="questionsDiv"><div><span class="questions-title">Confirmed: </span>The booking has been well confirmed with the hotel. </div><div><span class="questions-title">Pending: </span>The availability of your booking has to be further confirmed with the hotel for the pricing competitiveness. If the booking can be confirmed, we will notify you via E-mail within 10 minutes and the booking status will be changed to “Confirmed”. If, in rare cases, your booking cannot be confirmed, the booking status will be changed to “Cancelled”. </div><div><span class="questions-title">Unpaid: </span>The payment of your booking has not been completed yet. Your booking will be held available for maximum 5 minutes. If the booking remained “Unpaid” for 5 minutes, the booking status would be changed to “Cancelled”. To secure your reservation, please pay as soon as possible. </div><div><span class="questions-title">Cancelled: </span>The booking has been cancelled successfully. Please check your booking details for refund information if necessary.  </div></div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="update" ref="update">
              <div class="q-title">Modification</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="3-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">If I want to change the booking dates, how can I do it?</span></div>
                    <div class="questionsDiv">In this case, you will need to check the cancellation policy of your previous booking. If it is a refundable booking, you can cancel this one on our website and make a new reservation for the desired new dates. If it is non-refundable, please check with our agent via phone or email.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="3-2">
                    <div slot="title" class="questionsTitle"><span>2. </span> <span class="titleContent">Can I change the name of the lead guest?</span></div>
                    <div class="questionsDiv">Please reach out to our agents and they will help check and let you know if it is possible.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="3-3">
                    <div slot="title" class="questionsTitle"><span>3. </span> <span class="titleContent">How can I extend my stay?</span></div>
                    <div class="questionsDiv">If it is prior to arrival, please reach out to our agents and they will help check and let you know if it is possible.</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="cancel" ref="cancel">
              <div class="q-title">Cancellation</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="4-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">How can I cancel the booking?</span></div>
                    <div class="questionsDiv">You can cancel the booking online if it is within the cancellation policy. If it is a non-refundable booking and you have some special reasons, including any force majeure occasions, you will need to reach out to our agents and they will help .you.</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="4-2">
                    <div slot="title" class="questionsTitle"><span>2. </span> <span class="titleContent">How do I know if the booking has been cancelled successfully?</span></div>
                    <div class="questionsDiv">Once the booking is cancelled successfully, you will see the status of the booking change to “Cancelled” online and an automatic notification email will be sent to your email address.</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="covid" ref="covid">
              <div class="q-title">COVID-19</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="5-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent"> Can I make changes or cancel my reservation due to COVID-19?</span></div>
                    <div class="questionsDiv">We understand the on-going impact of COVID-19, but please be aware that any changes to your existing booking is subject to the cancellation policy of your booking. In case any incident related to COVID-19 happened before arrival, you may reach out to our agents and ask them for help.</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

          </div>

          <!-- 中文 -->
          <div class="q-left" v-if="languageCur === 'zh'" :style="qLeftFixedHeader">
            <span @mouseenter="imgAboutUs = 'https://res.roompai.com/static/img/question/aboutUs-blue.png'" @mouseleave="imgAboutUs = 'https://res.roompai.com/static/img/question/aboutUs-gray.png'" @click="anchorJumpLine('aboutUs')" :class="[{'left-active': anchorJumpStatus==='aboutUs'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgAboutUs" class="q-tag"></div>
              <div style="display: inline-block;">关于我们</div>
            </span>
            <span @mouseenter="imgMess = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgMess = 'https://res.roompai.com/static/img/question/mess-gray.png'" @click="anchorJumpLine('mess')" :class="[{'left-active': anchorJumpStatus==='mess'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgMess" class="q-tag"></div>
              <div style="display: inline-block;">一般信息</div>
            </span>
            <span @mouseenter="imgCreate = 'https://res.roompai.com/static/img/question/order-blue.png'" @mouseleave="imgCreate = 'https://www.roompai.com/static/img/question/order-gray.png'" @click="anchorJumpLine('create')" :class="[{'left-active': anchorJumpStatus==='create'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCreate" class="q-tag"></div>
              <div style="display: inline-block;">您的预订</div>
            </span>
            <span @mouseenter="imgUpdate = 'https://res.roompai.com/static/img/question/update-blue.png'" @mouseleave="imgUpdate = 'https://res.roompai.com/static/img/question/update-gray.png'" @click="anchorJumpLine('update')" :class="[{'left-active': anchorJumpStatus==='update'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgUpdate" class="q-tag"></div>
              <div style="display: inline-block;">订单修改</div>
            </span>
            <span @mouseenter="imgCancel = 'https://res.roompai.com/static/img/question/cancel-blue.png'" @mouseleave="imgCancel = 'https://res.roompai.com/static/img/question/cancel-gray.png'" @click="anchorJumpLine('cancel')" :class="[{'left-active': anchorJumpStatus==='cancel'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCancel" class="q-tag"></div>
              <div style="display: inline-block;">订单取消</div>
            </span>
            <span @mouseenter="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-blue.png'" @mouseleave="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-gray.png'" @click="anchorJumpLine('covid')" :class="[{'left-active': anchorJumpStatus==='covid'}]">
              <div style="display: inline-block;vertical-align: sub;"><img :src="imgCovid" class="q-tag"></div>
              <div style="display: inline-block;">COVID-19</div>
            </span>
          </div>

          <!-- <el-tabs type="card" class="q-left-mobile" v-if="languageCur === 'zh'">
            <el-tab-pane>
              <span slot="label" @mouseenter="imgMess = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgMess = 'https://res.roompai.com/static/img/question/mess-gray.png'"><img :src="imgMess" class="q-tag">一般信息</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCreate = 'https://res.roompai.com/static/img/question/mess-blue.png'" @mouseleave="imgCreate = 'https://res.roompai.com/static/img/question/mess-gray.png'"><img :src="imgCreate" class="q-tag">您的预订</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgUpdate = 'https://res.roompai.com/static/img/question/update-blue.png'" @mouseleave="imgUpdate = 'https://res.roompai.com/static/img/question/update-gray.png'"><img :src="imgUpdate" class="q-tag">订单修改</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCancel = 'https://res.roompai.com/static/img/question/cancel-blue.png'" @mouseleave="imgCancel = 'https://res.roompai.com/static/img/question/cancel-gray.png'"><img :src="imgCancel" class="q-tag">订单取消</span>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @mouseenter="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-blue.png'" @mouseleave="imgCovid = 'https://res.roompai.com/static/img/question/covid-19-gray.png'"><img :src="imgCovid" class="q-tag">COVID-19</span>
            </el-tab-pane>
          </el-tabs> -->
          <div class="q-left-mobile" v-if="languageCur === 'zh'" style="padding-bottom: 10px;">
            <el-select v-model="mobileValue" :placeholder="$t('pleaseSelect')" style="width: 100%;" @change="selectVal()">
              <el-option v-for="item in mobileSelectZh" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="q-right" :class="{'right-mobile': common.isMobile() === true}" v-if="languageCur === 'zh'">
            <div class="q-frequently" id="aboutUs" ref="aboutUs">
              <div class="q-title">关于我们</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="a1-1">
                    <div slot="title" class="questionsTitle">
                      <span>1. </span> <span class="titleContent">Roompai 是什么？</span>
                    </div>
                    <div class="questionsDiv">
                      <div>
                        <b>Roompai</b> 是一个酒店预订平台，旨在帮助用户以实惠的价格找到最佳住宿。该应用程序允许用户根据旅行需求（无论是商务还是休闲）搜索、比较和预订酒店。Roompai 确保提供流畅的预订体验，实时更新价格、可用性，并为注册用户提供独家折扣。
                        <br/>
                        <b>核心功能包括：</b>
                        <ul style="margin-left: 10px">
                          <li>搜索和比较 酒店价格、可用性和设施。</li>
                          <li>轻松安全地预订 房间。</li>
                          <li>为注册用户提供独家优惠。</li>
                        </ul>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="a1-2">
                    <div slot="title" class="questionsTitle">
                      <span>2. </span>
                      <span class="titleContent">Roompai 的目的是什么？</span>
                    </div>
                    <div class="questionsDiv">
                      <div>Roompai 是一个酒店预订平台，帮助旅行者找到最佳的住宿优惠。用户可以通过该应用程序搜索酒店、比较价格并直接进行预订。我们的使命是提供一种用户友好且高效的方式，让人们根据他们的具体需求（无论是商务还是休闲旅行）预订酒店。</div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="a1-3">
                    <div slot="title" class="questionsTitle">
                      <span>3. </span>
                      <span class="titleContent">Roompai 如何帮助我进行预订？</span>
                    </div>
                    <div class="questionsDiv">
                      <div>Roompai 提供实时更新的价格和可用性，允许您实时比较不同酒店。我们的应用确保安全的预订过程，并便于管理您的预订。</div>
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="mess" ref="mess">
              <div class="q-title">一般信息</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="1-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">联系信息</span></div>
                    <div class="questionsDiv"><!-- <div>联系电话: 86-411-00000000</div> --><div>邮箱: customersupport@roompai.com</div></div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="create" ref="create">
              <div class="q-title">您的预订</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="2-1">
                    <div slot="title" class="questionsTitle"><span>1. </span> <span class="titleContent">如何确定我的订单是否已经确认？</span></div>
                    <div class="questionsDiv">您完成预订后，我们会向您的注册邮箱自动发送订单确认信，其中包括您的订单编号。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-2">
                    <div slot="title" class="questionsTitle"><span>2. </span> <span class="titleContent">我什么时候会收到确认信？</span></div>
                    <div class="questionsDiv">通常您会在预订完成后的20分钟内收到此确认信。如果未正常收到，请检查您的垃圾邮件。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-3">
                    <div slot="title" class="questionsTitle"><span>3. </span> <span class="titleContent">如何查看我的预订信息？</span></div>
                    <div class="questionsDiv">请登录您的Roompai账户，在网站主页的“我的账户”中寻找“我的行程”，点击其中一个预订，将能查看具体预订信息。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-4">
                    <div slot="title" class="questionsTitle"><span>4.</span> <span class="titleContent">如何获取行程单？</span></div>
                    <div class="questionsDiv">您可以通过两种方式获取行程单。一是行程单会通过确认信附件以PDF文件形式发送给您，二是线上下载。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-5">
                    <div slot="title" class="questionsTitle"><span>5.</span> <span class="titleContent">如果我为另外一名客人预订，应该使用我的名字还是那位客人的名字？</span></div>
                    <div class="questionsDiv">请使用即将入住客人的姓名，以避免到店后产生入住问题。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-6">
                    <div slot="title" class="questionsTitle"><span>6.</span> <span class="titleContent">如何获取更多酒店相关信息？</span></div>
                    <div class="questionsDiv">您可以通过酒店详情页查看酒店相关的详细信息。如需了解更多，请致电我们或直接联系酒店询问。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-7">
                    <div slot="title" class="questionsTitle"><span>7.</span> <span class="titleContent">每一间房，我需要告知所有即将入住的旅客姓名吗？</span></div>
                    <div class="questionsDiv">不需要，您只需要通知我们其中一位客人的姓名即可。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-8">
                    <div slot="title" class="questionsTitle"><span>8.</span> <span class="titleContent">我对房间的特殊要求是否能确保满足？</span></div>
                    <div class="questionsDiv">关于您的特殊要求，我们会尽量通知到酒店。然而，请知悉我们无法确保一定会满足您的特殊，因为要看酒店的具体情况。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-9">
                    <div slot="title" class="questionsTitle"><span>9.</span> <span class="titleContent">如果房间与我预订的不一致，我应该怎么办？</span></div>
                    <div class="questionsDiv">请放心，我们的客服代表将竭尽全力帮助您解决问题。请致电：86-411-84949537</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-10">
                    <div slot="title" class="questionsTitle"><span>10.</span> <span class="titleContent">如果我到店时酒店要求我支付房费，我该怎么做？</span></div>
                    <div class="questionsDiv">请保留所需的相关发票或支付凭证并联系我们。我们的客服代表将会与酒店沟通以便解决您的问题并尽快操作退款。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="2-11">
                    <div slot="title" class="questionsTitle"><span>11.</span> <span class="titleContent">订单状态代表什么？</span></div>
                    <div class="questionsDiv"><div><span class="questions-title">已确认: </span>此订单已跟酒店完成确认。</div><div><span class="questions-title">待确认: </span>此订单状态需要进一步跟酒店确认，有可能您预订了我们的热门产品。如果订单可以确认，我们会在10分钟内以邮件方式通知到您。此时，预订状态将更改为“已确认”。极少数情况下，如果您的订单无法确认，则订单状态将会更改为“已取消”。 </div><div><span class="questions-title">待支付: </span>此预订还未完成。您的预订将会被锁定最多5分钟。5分钟之后，订单将自动取消，订单状态变更为“已取消”。请尽快完成支付以锁定您期望的房间。</div><div><span class="questions-title">已取消: </span>订单已成功取消。如果有退款产生，请查看订单详情。</div></div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="update" ref="update">
              <div class="q-title">订单修改</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="3-1">
                    <div slot="title" class="questionsTitle"><span>1.</span> <span class="titleContent">如何更改入住和离店时间？</span></div>
                    <div class="questionsDiv">如您想更改日期，请查看您预订对应的取消政策。如果订单可免费取消，您可以在网站取消相关订单并进行重新预订以满足您新的行程时间。如果订单不可取消，请通过电话或邮件方式联系我们的客服代表。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="3-2">
                    <div slot="title" class="questionsTitle"><span>2.</span> <span class="titleContent">我是否可以更改客人代表姓名？</span></div>
                    <div class="questionsDiv">请致电我们的客服代表，专员会查看信息并告知您是否可以进行相应更改。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="3-3">
                    <div slot="title" class="questionsTitle"><span>3.</span> <span class="titleContent">如何延长入住时间？</span></div>
                    <div class="questionsDiv">如果是未到店，您可以致电我们的客服代表，专员会查看信息并告知您是否可以延长入住时间。</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="cancel" ref="cancel">
              <div class="q-title">订单取消</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="4-1">
                    <div slot="title" class="questionsTitle"><span>1.</span> <span class="titleContent">如何取消我的订单？</span></div>
                    <div class="questionsDiv">如果是符合取消政策的预订，您可以在线进行取消。如果是不可取消订单，并且您有特殊原因，包括不可抗力的情况，您需要致电我们的客服代表，客服专员会为您提供帮助。</div>
                  </el-collapse-item>
                  <el-collapse-item class="questions" name="4-2">
                    <div slot="title" class="questionsTitle"><span>2.</span> <span class="titleContent">如何确认订单已取消成功？</span></div>
                    <div class="questionsDiv">订单取消成功后，订单的在线状态将更改为“已取消”。我们会向您的注册邮箱发送通知信。</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

            <div class="q-frequently" id="covid" ref="covid">
              <div class="q-title">COVID-19</div>
              <el-collapse v-model="activeMessName" accordion>
                <div class="content">
                  <el-collapse-item class="questions" name="5-1">
                    <div slot="title" class="questionsTitle"><span>1.</span> <span class="titleContent">因新冠疫情，我是否可以更改或取消我的订单？</span></div>
                    <div class="questionsDiv">我们理解新冠疫情的影响仍在持续，但是请理解对于您订单的任何更改都受限于订单本身的取消政策。如果受新冠疫情影响，您无法出行，请致电我们的客服代表寻求帮助。</div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>

          </div>

        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'frequently',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      languageCur: 'zh',
      activeMessName: '',
      activeCancelName: '',
      activeUpdateName: '',
      activeSpecialName: '',
      imgAboutUs: 'https://res.roompai.com/static/img/question/aboutUs-gray.png',
      imgMess: 'https://res.roompai.com/static/img/question/mess-gray.png',
      imgCreate: 'https://www.roompai.com/static/img/question/order-gray.png',
      imgUpdate: 'https://res.roompai.com/static/img/question/update-gray.png',
      imgCancel: 'https://res.roompai.com/static/img/question/cancel-gray.png',
      imgCovid: 'https://res.roompai.com/static/img/question/covid-19-gray.png',
      qLeftFixedHeader: '',
      anchorJumpStatus: 'mess',
      mobileSelectEn: [{value: 'aboutUs', label: 'About us'}, {value: 'mess', label: 'General information'}, {value: 'create', label: 'Booking'}, {value: 'update', label: 'Modification'}, {value: 'cancel', label: 'Cancellation'}, {value: 'covid', label: 'COVID-19'}],
      mobileSelectZh: [{value: 'aboutUs', label: '关于我们'}, {value: 'mess', label: '一般信息'}, {value: 'create', label: '您的预订'}, {value: 'update', label: '订单修改'}, {value: 'cancel', label: '订单取消'}, {value: 'covid', label: 'COVID-19'}],
      mobileValue: 'mess',
      source: 'roompai',
      conver: ''
    }
  },
  mounted () {
    var that = this
    setInterval(function () {
      that.languageCur = that.common.languageSet(that)
    }, 200)
    console.log(this.common.languageSet(this))

    if (this.common.isMobile() === false) {
      // 下滑搜索条置顶
      window.addEventListener('scroll', this.handleScroll)
    }

    // 手机版默认展示问题
    if (this.common.isMobile() === true) {
      window.scrollTo({
        top: 2000,
        behavior: 'instant'
      })
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      })
      // this.selectVal()
    }
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
    let conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  watch: {
    languageCur: function (n, o) {
    }
  },
  methods: {
    handleChange (val) {
      // console.log(val)
    },
    selectVal: function () {
      this.$refs.aboutUs.style.display = 'block'
      this.$refs.mess.style.display = 'block'
      this.$refs.create.style.display = 'block'
      this.$refs.update.style.display = 'block'
      this.$refs.cancel.style.display = 'block'
      this.$refs.covid.style.display = 'block'

      var mobileDom = this.$refs[this.mobileValue]
      mobileDom.style.display = 'block'

      // const height = document.querySelector('#' + this.mobileValue).offsetTop
      // const top = parseInt(height)
      var top = 0
      if (this.mobileValue === 'aboutUs') {
        top = 0
      } else if (this.mobileValue === 'mess') {
        top = 1000
      } else if (this.mobileValue === 'create') {
        top = 420 + 1000
      } else if (this.mobileValue === 'update') {
        top = 1050 + 1000
      } else if (this.mobileValue === 'cancel') {
        top = 1280 + 1000
      } else if (this.mobileValue === 'covid') {
        top = 1460 + 1000
      }

      var i = 10
      var int = setInterval(function () {
        window.scrollTo(0, i)
        i += 10
        if (i >= top) clearInterval(int)
      }, 1)
    },
    // 下拉置顶
    handleScroll: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 200 && scrollTop < 1085) {
        this.qLeftFixedHeader = {'position': 'fixed', 'top': '21%', 'z-index': 1999}
      } else if (scrollTop >= 1085) {
        this.qLeftFixedHeader = {'position': 'absolute', 'top': '940px'}
      } else {
        this.qLeftFixedHeader = ''
      }
    },
    anchorJumpLine: function (type) {
      // 方法一
      // this.$el.querySelector('#' + type).scrollIntoView({behavior: 'smooth'})

      // 方法二
      const height = document.querySelector('#' + type).offsetTop
      const top = parseInt(height)
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
      if (type === 'aboutUs') {
        this.imgAboutUs = 'https://res.roompai.com/static/img/question/aboutUs-blue.png'
      }
      if (type === 'mess') {
        this.imgMess = 'https://res.roompai.com/static/img/question/mess-blue.png'
      }
      if (type === 'create') {
        this.imgCreate = 'https://res.roompai.com/static/img/question/order-blue.png'
      }
      if (type === 'update') {
        this.imgUpdate = 'https://res.roompai.com/static/img/question/update-blue.png'
      }
      if (type === 'cancel') {
        this.imgCancel = 'https://res.roompai.com/static/img/question/cancel-blue.png'
      }
      if (type === 'covid') {
        this.imgCovid = 'https://res.roompai.com/static/img/question/covid-19-blue.png'
      }
      this.anchorJumpStatus = type
    },
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
/* PC */
  .el-main{text-align: left;}
  .q-main{background-color: #fff;width:100%;height:1500px; margin:0 auto;padding-bottom: 100px;}
  .q-top{width: 100%;height: 150px;background-color: rgba(252, 210, 5, 0.2980392156862745);border: none; text-align: center;line-height: 150px;}
  .q-top span{justify-content: center;align-items: center;height: 150px;font-weight: 500;font-size: 22px;color: #4F4C4C;}
  .q-info{width:1100px;height:auto; margin:30px auto;position:relative;}
  .q-tag{width:18px; height:18px; margin-right:8px;}
  /*左侧 */
  .q-left{ width:20%;display:inline-block; height:300px; float:left;margin-right:2%;}
  .q-left span{font-weight: 500;font-style: normal;font-size: 16px;color: #4F4C4C;display:block;margin-bottom:30px; cursor:pointer;}
  .q-left span:hover{color:#5392F9}
  /* 右侧 */
  .q-right{ display:inline-block;width:78%; float:left;position:absolute; right:0px;}
  .q-frequently{margin-bottom:30px;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;-moz-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);-webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);font-weight: 400;font-size: 16px;color: #4F4C4C;}
  .q-title{padding-left:16px;height:50px;font-weight: 650;font-size: 24px;color: #4F4C4C;line-height: 50px; border-bottom:1px solid rgba(242, 242, 242, 1);}
  /* 折叠框 */
  .el-collapse-item__header:hover{ background-color:rgba(255, 251, 230);}
  .el-collapse-item__header{font-weight: 500;font-size: 16px;color: #4F4C4C;text-indent: 1rem;}
  .el-collapse-item__content{padding:0px 10px 15px 10px;font-weight: 400;font-style: normal;font-size: 14px;color: #4F4C4C;}
  .el-collapse-item__header.is-active,.el-collapse-item__wrap{background-color:rgba(255, 251, 230);}
  .content{border-bottom: solid 1px #EBEEF5;}
  /*.el-collapse-item__header{line-height: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}*/
  .questions{}
  /*.q-info /deep/ .el-collapse-item__header {line-height: 30px;padding: 10px 0px;}*/
  .questions .questionsTitle{line-height: initial;padding-left:16px;margin:5px 0px;width:100%;}
  .questions .questionsTitle span{display:inline-block;width:15px;vertical-align: top;}
  .questions .questionsTitle .titleContent{width:90%;}
  .questions .questionsDiv{/*text-indent: 0rem;*/padding-left: 33px;width: 80%;}
  .questions-title{font-weight:800;}
  .left-active{}
  /deep/ .el-collapse-item__header:hover{color:#5392F9!important;}
  /deep/ .is-active{background:#FFFBE6!important;}
  /deep/ .is-active .el-collapse-item__wrap{background:#FFFBE6!important;}\

/* 手机 */
  .q-info .q-left-mobile{margin-bottom:10px;}
  .top-mobile{line-height: unset;height: auto;text-align:left;background-color: rgba(252, 210, 5, 0.2980392156862745);border: none;width:auto;padding: 50px 40px 50px;}
  .top-mobile span{height:auto;display:inline;font-size: 14px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;width: 90%;}
  .top-first-mobile{padding-top:50px;}
  .q-left-mobile /deep/ .el-select:hover .el-input__inner{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 6px rgb(252 210 5);}
  .el-select{-webkit-tap-highlight-color: transparent !important;}

  .right-mobile /deep/ .el-collapse-item__header:hover{ color:#303133!important;}
  .right-mobile /deep/ .el-collapse-item__header.is-active{ color:#5392F9!important;}
  .right-mobile .q-frequently{margin-bottom:10px;}
/* 响应式 */
  @charset "UTF-8";

  @media only screen and (max-width:390px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:90%;}
    .q-info .q-left{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .questions .questionsTitle{font-size:12px;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:390px) and (max-width:490px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:90%;}
    .q-info .q-left{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:490px) and (max-width:768px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:90%;}
    .q-info .q-left{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:768px) and (max-width:870px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:90%;}
    .q-info .q-left{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:870px) and (max-width:992px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:90%;}
    .q-info .q-left{display:none;}
    .q-info .q-left-mobile .el-tabs--border-card .el-tabs__content{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:992px) and (max-width:1200px){
    /* 左侧栏隐藏 */
    .q-main .q-info{width:1100px;}
    .q-info .q-left{display:none;}
    .q-info .q-left-mobile .el-tabs--border-card .el-tabs__content{display:none;}
    .q-info .q-right{width:100%;}

    .q-info .q-title{font-size:16px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;}
    .q-info /deep/ .el-collapse-item__header{font-size:14px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;}
    .q-info .questions .questionsDiv{font-size:12px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  }

  @media only screen and (min-width:1200px) and (max-width:1400px) {
    .q-info .q-left{}
    .q-info .q-left-mobile{display:none;}
  }

  @media only screen and (min-width:1400px) and (max-width:1920px) {
    .q-info .q-left{}
    .q-info .q-left-mobile{display:none;}
  }

  @media only screen and (min-width:1920px) {
    .q-info .q-left{}
    .q-info .q-left-mobile{display:none;}
  }
</style>



// WEBPACK FOOTER //
// src/components/question/frequently.vue